import script from "./TNC.vue?vue&type=script&lang=ts&setup=true"
export * from "./TNC.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__